
import Vue from 'vue'

export default Vue.extend({
  name: 'ChefBookPersonalInformation',
  props: {
    booker: {
      type: Object,
      required: true
    }
  },
})
